import type {
  BetProductWithSportsbook,
  PlayerPropsSecondaryFiltersParams,
  PlayerProp,
  SportsbookType,
  SDKWeek,
} from '@pff-consumer/schema'
import { useDispatch, useSelector } from 'react-redux'
import { bettingActions, bettingSelectors } from './betting.slice'

const {
  addToBetsCart,
  clearAllBets,
  clearBetsCartForSportsbook,
  closeBetsCartScreen,
  openBetsCartScreen,
  closeBetLimitModal,
  removeFromBetsCart,
  setEventsLockoutState,
  setSportsbookState,
  setSelectedEventId,
  setPlayerPropSportsbookFilter,
  setPlayerPropMarketFilter,
  setPlayerPropWeekFilter,
  setPlayerPropPositionFilter,
  setPlayerPropSortByFilter,
  setPlayerPropSecondaryFilters,
  setCurrentEventWeek,
} = bettingActions

export const bettingHooks = {
  useBetsCartState: () => useSelector(bettingSelectors.getBetsCartState),
  useBetSlipCount: () => useSelector(bettingSelectors.getBetSlipCount),
  useCartBetCategoryCount: () => useSelector(bettingSelectors.getCartBetCategoryCount),
  useCartBetDetailedTypeCount: () => useSelector(bettingSelectors.getCartDetailedBetTypeCount),
  useCartBetGeneralTypeCount: () => useSelector(bettingSelectors.getCartGeneralBetTypeCount),
  useCartGameIdCount: () => useSelector(bettingSelectors.getCartGameIdCount),
  useCartTeamCount: () => useSelector(bettingSelectors.getCartTeamCount),
  useCartGameTimesCount: () => useSelector(bettingSelectors.getCartGameTimesCount),
  useLockedEventsState: () => useSelector(bettingSelectors.getLockedEventsState),
  useSelectedEventId: () => useSelector(bettingSelectors.getSelectedEventId),
  useSportsbookId: () => useSelector(bettingSelectors.getSportsbookId),
  usePlayerPropSportsbookFilter: () => useSelector(bettingSelectors.getPlayerPropSportsbookFilter),
  usePlayerPropMarketFilter: () => useSelector(bettingSelectors.getPlayerPropMarketFilter),
  usePlayerPropWeekFilter: () => useSelector(bettingSelectors.getPlayerPropWeekFilter),
  usePlayerPropPositionFilter: () => useSelector(bettingSelectors.getPlayerPropPositionFilter),
  usePlayerPropSortByFilter: () => useSelector(bettingSelectors.getPlayerPropSortByFilter),
  useLeague: () => useSelector(bettingSelectors.getLeague),
  useCurrentSeason: () => useSelector(bettingSelectors.getSeason),
  usePlayerPropFilters: () => useSelector(bettingSelectors.getPlayerPropFilters),
  useCurrentEventWeek: () => useSelector(bettingSelectors.getCurrentEventWeek),
  useCurrentEventWeekStatus: () => useSelector(bettingSelectors.getCurrentEventWeekStatus),
  usePlayerPropSelectedSecondaryFiltersCount: () =>
    useSelector(bettingSelectors.getPlayerPropSelectedSecondaryFiltersCount),
  usePlayerPropsSelectedSeason: () => useSelector(bettingSelectors.getPlayerPropSelectedSeason),
  useGetCurrentEventWeekForPlayerProps: () => useSelector(bettingSelectors.getCurrentEventWeekForPlayerProps),
  useBettingActions: () => {
    const dispatch = useDispatch()
    return {
      addToBetsCart: (payload: BetProductWithSportsbook | PlayerProp) => {
        dispatch(addToBetsCart(payload))
      },
      removeFromBetsCart: (payload: BetProductWithSportsbook | PlayerProp) => {
        dispatch(removeFromBetsCart(payload))
      },
      clearAllBets: () => {
        dispatch(clearAllBets())
      },
      clearBetsCartForSportsbook: (payload: SportsbookType) => {
        dispatch(clearBetsCartForSportsbook(payload))
      },
      openBetsCartScreen: () => {
        dispatch(openBetsCartScreen())
      },
      closeBetsCartScreen: () => {
        dispatch(closeBetsCartScreen())
      },
      closeBetLimitModal: () => {
        dispatch(closeBetLimitModal())
      },
      disableEventsLockout: () => {
        dispatch(setEventsLockoutState(false))
      },
      enableEventsLockout: () => {
        dispatch(setEventsLockoutState(true))
      },
      setSelectedEventId: (payload: number | undefined) => {
        dispatch(setSelectedEventId(payload))
      },
      setSportsbookId: (payload: SportsbookType) => {
        dispatch(setSportsbookState(payload))
      },
      setPlayerPropSportsbookFilter: (payload: SportsbookType) => {
        dispatch(setPlayerPropSportsbookFilter(payload))
      },
      setPlayerPropMarketFilter: (payload: string) => {
        dispatch(setPlayerPropMarketFilter(payload))
      },
      setPlayerPropWeekFilter: (payload: string) => {
        dispatch(setPlayerPropWeekFilter(payload))
      },
      setPlayerPropPositionFilter: (payload: string) => {
        dispatch(setPlayerPropPositionFilter(payload))
      },
      setPlayerPropSortByFilter: (payload: string) => {
        dispatch(setPlayerPropSortByFilter(payload))
      },
      setCurrentEventWeek: (payload: SDKWeek) => {
        dispatch(setCurrentEventWeek(payload))
      },
      setPlayerPropSecondaryFilters: ({ payload }: { payload: PlayerPropsSecondaryFiltersParams }) => {
        dispatch(setPlayerPropSecondaryFilters(payload))
      },
      setPlayerPropsSelectedSeason: (payload: string) => {
        dispatch(bettingActions.setPlayerPropSelectedSeason(payload))
      },
    }
  },
}
